import type { Company } from '@dcc-erp/shared';
import { Icon } from '@dcc-erp/ui';

import { useAuth } from '../../lib/auth';
import { useCompanies } from '../../lib/queries/companies';

export interface AppHeaderProps {
  company: Company;
  page: string;
  onLogout: () => void;
}

function initialsOf(name: string | undefined): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]![0] ?? '') : '';
  return (first + last).toUpperCase() || '?';
}

export function AppHeader({ company, onLogout }: AppHeaderProps) {
  const { user, activeCompanyId, setActiveCompanyId } = useAuth();
  const { data: companies = [] } = useCompanies();
  const allowed = companies.filter((c) => c.id && user?.allowedCompanyIds.includes(c.id));

  return (
    <div className="app-header">
      <div className="brand-block">
        <div className="brand-mark">{company.code}</div>
        <div className="header-sep" />
        <div className="header-meta">
          <span>{company.nameTh}</span>
          <span className="pill">เลขประจำตัวผู้เสียภาษี {company.taxId}</span>
        </div>
      </div>
      <div className="header-meta">
        {allowed.length > 0 && (
          <select
            className="select sm"
            style={{
              background: '#fff',
              border: '1px solid var(--border)',
              borderRadius: 6,
              padding: '4px 8px',
              fontSize: 13,
              color: '#1a1a1a',
              cursor: 'pointer',
              minWidth: 220,
            }}
            value={activeCompanyId ?? ''}
            onChange={(e) => setActiveCompanyId(e.target.value)}
            title="สลับบริษัท"
          >
            {allowed.map((c) => (
              <option key={c.id} value={c.id}>
                {c.code} — {c.nameTh}
              </option>
            ))}
          </select>
        )}
        <span className="pill">งวด 04/2026 · เปิดอยู่</span>
        <button className="icon-btn" title="ค้นหา">
          <Icon name="search" size={16} />
        </button>
        <button className="icon-btn" title="แจ้งเตือน">
          <Icon name="bell" size={16} />
        </button>
        <button className="icon-btn" title="ตั้งค่า">
          <Icon name="settings" size={16} />
        </button>
        <div className="user-chip">
          <div className="avatar">{initialsOf(user?.displayName)}</div>
          <div>
            {user?.displayName ?? user?.email ?? 'ผู้ใช้งาน'}{' '}
            <span style={{ opacity: 0.7 }}>· {user?.preferredUsername ?? ''}</span>
          </div>
        </div>
        <button className="icon-btn" title="ออกจากระบบ" onClick={onLogout} aria-label="ออกจากระบบ">
          <Icon name="x" size={16} />
        </button>
      </div>
    </div>
  );
}
